<template>
	<UiModalMobile
		v-model="modelValue"
		class="modal__mobile"
		:titleBtnSave="$t('Добавить')"
		:isDontNeedCloseWhenSave="true"
		@save="saveHandler"
		height="unset"
		min-height-body="unset"
		maxHeight="fit-content"
		:is-loading-btn-save="props.isLoading"
		:z-index="zIndex"
	>
		<TypographyKTypographyBody2
			color="var(--color_font_black_wite)"
			font-type="bold"
		>
			{{ $t('Добавить комментарий') }}
		</TypographyKTypographyBody2>
		<div class="wrapper">
			<UiTextArea
				:label="$t('Комментарий')"
				max-width="none"
				background-color-input="var(--violet-6)"
				:input-special-style="{ fontSize: '15px' }"
				v-model="text"
				:border-width-input="errorField.text ? '1px' : '0px'"
				:error="errorField.text"
				:is-clearable="true"
				@blur="clearError(`text`)"
			>
				<template #label-extra>
					<UiSelect
						v-model="importance"
						class="label-select"
						height="30px"
						max-width="200px"
						:items="typeCommentComputed"
						:inputSpecialStyle="{ color: getColorByItem({ id: importance?.id }) }"
					>
						<template #left-icon="{}">
							<UiIcon
								name="warning"
								folder="warning"
								width="20px"
								height="20px"
								:color="getColorByItem({ id: importance?.id })"
							/>
						</template>
						<template #item="{ item }">
							<div class="ui-select__item">
								<UiIcon
									name="warning"
									folder="warning"
									width="20px"
									height="20px"
									:color="getColorByItem(item.item)"
								/>
								<TypographyKTypographyBody4 :color="getColorByItem(item.item)">
									{{ item.item?.name }}
								</TypographyKTypographyBody4>
							</div>
						</template>
					</UiSelect>
				</template>
			</UiTextArea>
		</div>
	</UiModalMobile>
</template>

<script setup lang="ts">
	import { TYPE_COMMENT } from '~/const/ui';
	import { VALIDATE_RULES, validator } from '~/helpers/validate';

	const emits = defineEmits(['save']);
	const modelValue = defineModel('modelValue', { required: true, type: Boolean });
	const props = withDefaults(
		defineProps<{
			currentCargo: { id: string };
			isLoading?: boolean;
			zIndex?: number;
		}>(),
		{}
	);
	const typeComment = ref<string | null>(null);
	const text = ref<string>('');
	const typeCommentComputed = computed(() => {
		return Object.values(TYPE_COMMENT);
	});
	const importance = ref(typeCommentComputed.value[0] || null);

	const errorField = ref({
		text: { status: false, msg: '' }
	});

	const clearError = (type: string) => {
		errorField.value = { ...errorField.value, [type]: { status: false } };
	};

	const getColorByItem = (item: string | { id: string; name: string }) => {
		if (typeof item === 'object') {
			if (item?.id === '0') {
				return '#006EA9';
			} else if (item?.id === '1') {
				return '#E0C647';
			} else if (item?.id === '2') {
				return '#E32F3E';
			}
		}
		return '#006EA9';
	};

	const validateHandler = () => {
		const arrayRules: Array<{
			field: string;
			value: string | null;
			rules: VALIDATE_RULES[];
		}> = [{ field: 'text', value: text.value, rules: [VALIDATE_RULES.required] }];
		arrayRules.forEach((item) => {
			errorField.value = { ...errorField.value, [item.field]: validator(item.value, item.rules)[0] };
		});
	};

	const saveHandler = () => {
		validateHandler();
		if (!Object.values(errorField.value).find((item) => item.status)) {
			emits('save', {
				cargoId: props.currentCargo.id,
				text: text.value,
				importance: importance.value?.id
			});
		}
	};

	const chooseTypeComment = (items: string) => {
		typeComment.value = items;
	};
</script>

<style scoped lang="scss">
	.modal__mobile {
		display: flex;
		flex-direction: column;

		.ui-select__item {
			display: flex;
			align-items: center;

			.icon {
				margin-right: 5px;
			}
		}

		.label-select {
			margin-left: auto;
		}

		.upper-limit-clue {
			max-width: 300px;
			@media (max-width: $sm) {
				max-width: 200px;
			}
		}

		.input__secret {
			display: flex;
			flex-direction: column;
			gap: 8px;
			margin-bottom: -10px;
		}

		.wrapper {
			display: flex;
			flex-direction: column;
			overflow: auto;
			gap: 17px;
			margin-top: 14px;
			padding-right: 10px;
			margin-right: -10px;
			padding-bottom: 18px;

			.switch-wrapper {
				margin-top: 0px;
				display: flex;
				align-items: center;
				gap: 14px;
			}
		}
	}
</style>
